import { Link } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import Seo from "../../components/feature/Seo";

const values = [
  { icon: "ri-compass-3-line", title: "内容多元", desc: "从少年热血到恋爱日常，覆盖少年、少女、玄幻、悬疑、科幻等众多题材，满足不同口味的读者。" },
  { icon: "ri-heart-line", title: "品质为先", desc: "编辑团队从画风、剧情、完成度等多角度把关，层层筛选优质作品，把好书带给你。" },
  { icon: "ri-community-line", title: "贴近读者", desc: "以读者的搜索意图为中心组织分类与排行，让你更快找到想看的内容。" },
  { icon: "ri-seedling-line", title: "持续成长", desc: "书库持续扩充，同步最新连载与完结佳作，让每一本好书都能被看见。" },
];

const principles = [
  "分类清晰，书库齐全，方便快速定位",
  "人气排行动态更新，紧跟读者偏好",
  "编辑精选严格筛选，保证作品品质",
  "完结作品完整收录，可一次看完",
  "支持正版原创，尊重作者劳动",
  "持续收集反馈，不断优化体验",
];

const testimonials = [
  { name: "漫友·小鹿", text: "分类做得特别细，想找哪类漫画都很快，编辑精选踩雷率很低，每部都好看。" },
  { name: "漫友·阿凯", text: "人气排行很准，跟着榜单一周看完了好几部热血好漫，追更体验很棒。" },
  { name: "漫友·星野", text: "完结推荐太适合我了，直接看完全部剧情不用等更新，故事完整不烂尾。" },
];

export default function About() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <Seo
        title="关于我们 - 策驰漫画网"
        description="了解策驰漫画网的品牌介绍、网站定位、发展理念与内容原则。策驰漫画网致力于帮读者发现优质漫画，提供分类书库、人气排行与编辑精选推荐。"
        canonical="https://artbinge.github.io/guanyu"
      />

      <section className="pt-16 md:pt-[72px] bg-accent-600 relative overflow-hidden">
        <div className="absolute -top-10 -left-8 w-52 h-52 rounded-full bg-primary-500/30 blur-2xl"></div>
        <div className="relative z-10 mx-auto max-w-7xl w-full px-4 md:px-6 py-10 md:py-12">
          <nav aria-label="面包屑" className="text-accent-100 text-xs md:text-sm mb-3">
            <ol className="flex flex-wrap items-center gap-1.5">
              <li><Link to="/" className="hover:text-background-50">首页</Link></li>
              <li aria-hidden="true"><i className="ri-arrow-right-s-line"></i></li>
              <li className="text-background-50">关于我们</li>
            </ol>
          </nav>
          <h1 className="font-heading text-3xl md:text-4xl text-background-50">关于策驰漫画网</h1>
          <p className="mt-2 text-accent-100 text-sm md:text-base">发现好漫画，从这里开始</p>
        </div>
      </section>

      {/* 品牌介绍 */}
      <section className="mx-auto max-w-7xl w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div>
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium"><i className="ri-quill-pen-fill"></i>我们的初心</span>
            <h2 className="mt-4 font-heading text-2xl md:text-3xl text-primary-700">让每一本好漫画都被看见</h2>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              策驰漫画网是一个致力于帮读者发现优质漫画的平台。我们深知在海量作品里找到合口味的一部并不容易，因此从创立之初，就把"分类清晰、排行可靠、推荐靠谱"作为核心理念。
            </p>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              平台书库覆盖少年热血、恋爱日常、玄幻奇幻、悬疑推理、科幻机甲等众多题材，通过人气排行、编辑精选与完结推荐等多种方式，帮你快速定位想看的漫画，让每一部作品都有机会被真正喜欢它的读者遇见。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link to="/fenlei" className="whitespace-nowrap px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors">浏览漫画库</Link>
              <Link to="/lianxi" className="whitespace-nowrap px-6 py-3 rounded-full bg-background-100 border border-background-200 text-foreground-700 text-sm font-semibold hover:bg-primary-100 transition-colors">联系我们</Link>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div className="rounded-2xl overflow-hidden h-64 md:h-72"><img src="https://readdy.ai/api/search-image?query=Colorful%20stack%20of%20anime%20manga%20books%20on%20a%20warm%20desk%20with%20reading%20glasses%20and%20a%20steaming%20cup%2C%20cozy%20reading%20corner%2C%20warm%20coral%20and%20cream%20tones%2C%20stylish%20illustration%2C%20clean%20background%2C%20high%20detail&width=800&height=1000&seq=about-01&orientation=portrait" alt="策驰漫画网阅读角场景" className="w-full h-full object-cover object-top" loading="lazy" /></div>
            <div className="rounded-2xl overflow-hidden h-64 md:h-72 mt-8"><img src="https://readdy.ai/api/search-image?query=Two%20friends%20excitedly%20discussing%20comics%20around%20a%20laptop%20with%20anime%20cover%20art%20on%20screen%2C%20warm%20cozy%20study%20room%2C%20coral%20and%20golden%20tones%2C%20stylish%20illustration%2C%20clean%20background%2C%20high%20detail&width=800&height=1000&seq=about-02&orientation=portrait" alt="读者交流分享漫画" className="w-full h-full object-cover object-top" loading="lazy" /></div>
          </div>
        </div>
      </section>

      {/* 核心价值 */}
      <section className="bg-background-100 py-12 md:py-16">
        <div className="mx-auto max-w-7xl w-full px-4 md:px-6">
          <h2 className="text-center font-heading text-2xl md:text-3xl text-primary-700 mb-8">我们的核心价值</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {values.map((v) => (
              <div key={v.title} className="bg-background-50 border border-background-200/70 rounded-2xl p-5 hover:-translate-y-1 hover:border-primary-300 transition-all">
                <span className="w-12 h-12 rounded-xl bg-primary-100 text-primary-700 flex items-center justify-center text-xl"><i className={v.icon}></i></span>
                <h3 className="mt-4 font-bold text-foreground-950">{v.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 内容原则 */}
      <section className="mx-auto max-w-7xl w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-primary-700">我们的内容原则</h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">为读者负责，为作品负责，是策驰漫画网一直坚持的准则。</p>
            <ul className="mt-6 space-y-3">
              {principles.map((p) => (
                <li key={p} className="flex items-start gap-3 text-sm text-foreground-700">
                  <span className="mt-0.5 w-5 h-5 rounded-full bg-secondary-100 text-secondary-900 flex items-center justify-center shrink-0"><i className="ri-check-line text-xs"></i></span>
                  {p}
                </li>
              ))}
            </ul>
          </div>
          <div className="bg-secondary-50 border border-secondary-200 rounded-2xl p-6 md:p-8 flex flex-col justify-center">
            <i className="ri-double-quotes-l text-4xl text-secondary-400"></i>
            <p className="mt-3 font-heading text-lg md:text-xl text-secondary-900 leading-relaxed">我们相信，每一部用心创作的作品，都值得被认真对待；每一位认真阅读的读者，都值得被真诚回馈。</p>
            <p className="mt-4 text-sm text-secondary-700">—— 策驰漫画网团队</p>
          </div>
        </div>
      </section>

      {/* 用户口碑 */}
      <section className="bg-background-100 py-12 md:py-16">
        <div className="mx-auto max-w-7xl w-full px-4 md:px-6">
          <h2 className="text-center font-heading text-2xl md:text-3xl text-primary-700 mb-8">读者口碑</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {testimonials.map((t) => (
              <figure key={t.name} className="bg-background-50 border border-background-200/70 rounded-2xl p-5">
                <div className="flex items-center gap-1 text-accent-500 text-sm mb-3">
                  <i className="ri-star-fill"></i><i className="ri-star-fill"></i><i className="ri-star-fill"></i><i className="ri-star-fill"></i><i className="ri-star-fill"></i>
                </div>
                <blockquote className="text-sm text-foreground-700 leading-relaxed">“{t.text}”</blockquote>
                <figcaption className="mt-4 flex items-center gap-2 text-sm text-foreground-600">
                  <span className="w-8 h-8 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center font-bold"><i className="ri-user-smile-line"></i></span>
                  {t.name}
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      {/* 联系方式CTA */}
      <section className="mx-auto max-w-4xl w-full px-4 md:px-6 py-12 md:py-16 text-center">
        <h2 className="font-heading text-2xl md:text-3xl text-primary-700">有任何建议或合作意向？</h2>
        <p className="mt-3 text-sm text-foreground-600">欢迎随时与我们联系，你的每一条反馈都是我们前进的动力。</p>
        <Link to="/lianxi" className="mt-6 inline-flex items-center gap-2 whitespace-nowrap px-7 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors">
          联系我们 <i className="ri-arrow-right-line"></i>
        </Link>
      </section>

      <Footer />

      {/* AboutPage 结构化数据 */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "AboutPage",
        "name": "关于策驰漫画网",
        "description": "策驰漫画网是致力于帮读者发现优质漫画的平台，提供分类书库、人气排行与编辑精选推荐。",
        "inLanguage": "zh-CN",
      }) }} />
    </div>
  );
}